import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, vShow as _vShow, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

import { computed, onBeforeUnmount, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    url: null,
    theme: null
  },
  setup(__props: any) {

const props = __props as {
    url?: string,
    theme?: string
}


const style = computed(() => {
    if (props.url) {
        return {
            'backgroundImage': 'url(' + props.url + ')'
        }
    }
})

const ready = ref(false);
const poster = ref();

onMounted(() => {
    onPageScroll();
    if (!ready.value) {
        window.addEventListener('scroll', onPageScroll)
    }
})


onBeforeUnmount(() => {
    window.removeEventListener('scroll', onPageScroll)
})

function onPageScroll() {
    let { top } = poster.value.getBoundingClientRect()
    if (top < window.innerHeight) {
        ready.value = true;
        window.removeEventListener('scroll', onPageScroll)
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "poster",
    ref_key: "poster",
    ref: poster
  }, [
    (__props.theme == 'album' && ready.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["default", __props.theme])
        }, null, 2))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", {
      class: "loader",
      style: _normalizeStyle(_unref(style))
    }, null, 4), [
      [_vShow, ready.value]
    ])
  ], 512))
}
}

})